<template>
  <div v-loading="rcapLoading">
    <!-- 公式 -->
    <el-row type="flex" justify="center">
      <p class="formulaRow" >
        Realized Cap = value · price  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  <span class="created">created</span>         
         
       <span style="color:rgba(0,0,0,0.4)" >[USD] (of all UTXOs)</span> 
      </p>
    </el-row>
    <!-- 对数线性显示切换 -->

    <!-- <el-row class="switch">
      <el-col>
         <el-button @click="handelLineSwitch"
         style="margin-left:100px;height:35px;border-radius:6px;"
         >{{ $t(`home.switch`)
          }}<span class="according"> {{ $t(switch3) }}</span></el-button
        >
      </el-col>
    </el-row> -->
    <el-row>
      <el-col :span="24">
        <div id="rcapBox" style="width: 100%; min-height: 700px"></div>
      </el-col>
    </el-row>
    <!-- <div class="formulaBox">
      <p>{{ $t(`home.formula`) }}</p>
      <p>
        Realized Cap = value . price<span>created</span> [USD] (of all UTXOs)
      </p>
    </div> -->
  </div>
</template>

<script>
import IndexJs from "../rcap/index";
export default {
  mixins: [IndexJs],
};
</script>

<style lang="scss" scoped>
.formulaBox {
  width: 98.7%;
  padding: 10px 0px;
  margin-bottom: -30px;
  font-size: 18px;
  // height: 60px;
  background: #e5e5e5;
  color: rgba(0, 0, 0, 0.6);
  p {
    margin: 0;
    padding: 0px 10px;
    margin-top: 5px;
    span {
      font-size: 12px;
    }
  }
}
.formulaRow {
  font-weight: 550;
  color: rgba(0, 0, 0, 0.6);
  // outline: 1px solid red;
  // height: 40px;
  position: relative;
  .created{
    position: absolute;
    left: 51%;
    font-size: 12px;
    top: 10px;
    color: rgba(0, 0, 0, 0.6);

  }
}
</style>